module.exports = __webpack_public_path__ + "img/shrine_of_destruction_small.3b640dd8.png";